import { render, staticRenderFns } from "./SectionSpecs.vue?vue&type=template&id=18d4d8a1&"
import script from "./SectionSpecs.vue?vue&type=script&lang=js&"
export * from "./SectionSpecs.vue?vue&type=script&lang=js&"
import style0 from "./SectionSpecs.vue?vue&type=style&index=0&id=18d4d8a1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports